import { PickerType } from '@danielmoncada/angular-datetime-picker';
import { DatepickerRangeModel, IconNames } from '../../../common';
import { FilterType } from '../constants';

export class SelectOption {
  name: string;
  value: unknown;

  constructor(params?: SelectOption | string) {
    if (params) {
      if (typeof params === 'string') {
        this.name = params;
        this.value = params;
      } else {
        Object.assign(this, params);
      }
    }
  }
}

export class FilterControl {
  name: string;
  initialValue: unknown;
  disabled = false;
}

export class FilterItemBase extends FilterControl {
  type: FilterType;
  label: string;
  placeholder: string;
}

export class FilterSearch extends FilterItemBase {
  type = FilterType.Search;
  label = 'common.filter.search.label';
  placeholder = 'common.filter.placeholder';
  debounceTime = 500;
  initialValue: string | string[] = '';

  constructor(params?: Partial<FilterSearch>) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FilterSearchChips extends FilterSearch {
  type = FilterType.SearchChips;
  icon = IconNames.Search;
  initialValue = [];

  constructor(params?: Partial<FilterSearchChips>) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FilterCustomSearch extends FilterSearch {
  type = FilterType.CustomSearch;
  icon: IconNames;

  constructor(params?: Partial<FilterCustomSearch>) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FilterSelect extends FilterItemBase {
  type = FilterType.Select;
  label = 'common.filter.partnerType.label';
  placeholder = 'common.filter.partnerType.placeholder';
  isMultiple = false;
  options: SelectOption[] = [];

  constructor(params?: Partial<FilterSelect>) {
    super();
    if (params) {
      Object.assign(this, params);
      if (params.isMultiple) {
        this.initialValue = params.initialValue || [];
      } else {
        this.initialValue = params.initialValue || '';
        this.options.push(new SelectOption({ name: 'common.filter.option.all', value: '' }));
      }
    }
  }
}

export class FilterToggleGroup extends FilterItemBase {
  type = FilterType.ToggleGroup;
  options: SelectOption[] = [];

  constructor(params?: Partial<FilterToggleGroup>) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FilterDateTimeRange extends FilterItemBase {
  type = FilterType.DateTimeRange;
  label = 'monitoring.filters.timeRange';
  pickerType: PickerType = 'both';
  initialValue: DatepickerRangeModel;

  constructor(params?: Partial<FilterDateTimeRange>) {
    super();

    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FilterSettings {
  items: AnyFilterItem[];
}

export type AnyFilterItem =
  | FilterControl
  | FilterItemBase
  | FilterSearch
  | FilterSelect
  | FilterToggleGroup
  | FilterSearchChips
  | FilterDateTimeRange
  | FilterCustomSearch;
